
export enum Constants {
  RegexPatternAlphaNumeric = '^[a-zA-Z0-9 ]+$',
  RegexPatternOnlyNumeric = '^[0-9]*$',
  RegexPatternVarCharDataType = '^[a-zA-Z0-9_.\/-]*$',
  RegexPatternNumberDataType = '[0-9]+',
  RegexPatternCodeValue = '^[9, 0-9]*$',
  RegexPatternExponential = '^[0-9]+([eE][-+]?[0-9]+)?$',
  RegexPatternProjectNumber = '^[A-Z]{3}[0-9]{10}$',
  RegexPatternPlanNumber = '^[0-9]{1}[.]{1}[A-Z0-9]{3}$',
  RegexPatternEmail = '^([a-zA-Z0-9.]+@nycsca.org)$',
  RegexPatternFmsNum = '^[a-zA-Z0-9_.*-]*$',               // special Char Allowed:  _.-*  //
  RegexPatternOrigLoc = '^[a-zA-Z0-9 ,\/\`]*$',            // special Char Allowed:  `,/  //
  RegexPatternProjLiason = '^[a-zA-Z0-9 \\/\\-$,().?]*$',  // special Char Allowed:  /-$,().?  //
  RegexPatternTcuLoc = '^[a-zA-Z0-9 \/]*$',                // special Char Allowed:  /  //
  RegexPatternTitleProg = '^[a-zA-Z0-9 \\/\\-#.*,@&\']*$', // special Char Allowed:  /-#.,@&'  //
  RegexPatternJobType = '^[a-zA-Z0-9+]*$',                 // special Char Allowed:  +  //
  // RegexPatternComment = '^[a-zA-Z0-9!@#$%*()-+=[]:";\'\.\/,\?`{}\]*$',   // special Char Allowed:  /-$,().?  //
  // RegexPatternScaRejectReason = '^[a-zA-Z0-9#,.()-:",.\\/\']*$',         // special Char Allowed:  #&,.()-:",./'  //
  RegexPatternViolationNum = '^[a-zA-Z0-9-\\\/\`]*$',                       // special Char Allowed:  / `  //
  // RegexPatternDisposalReason = '^[a-zA-Z0-9#,\\/\\-.]*$',                // special Char Allowed:  #,/-.  //
  AccessToken = 'access_token',
  UnauthorizedAccessEvent = 'unAuthorizedAccess',
  AccessProjectFromMenuEvent = 'accessProjectFromMenuEvent',
  MsalLoginSuccessEvent = 'loginSuccess',
  InitiateLlwInProgressEvent = 'initiateLlwInProgressEvent',
  IsAuthenticated = 'authenticated',
  IsUserLoggedIn = 'loggedIn',
  ConnectionTimeoutErrorEvent = 'connectionTimeoutError',
  FormValid = 'VALID',
  FormInvalid = 'INVALID',
  FormDisabled = 'DISABLED',
  FilterContainOperator = 'contains',
  FilterStartsWithOperator = 'startsWith',
  LoggedInUserData = 'loggedInUserData',
  SearchedProjectData = 'searchedProjectData',
  UserPrefGridPageSize = 'userPreferenceGridPageSize',
  timeBeforeTokenRefresh = 2000,
  timeBeforeSessionRefresh = 300000, // 5 mins
  SessionStorage = 'sessionStorage',
  Filter_Contain_Operator = 'contains',
  Filter_StartsWith_Operator = 'startsWith',

  Kendo_Operation_Add = 1,
  Kendo_Operation_Edit = 2,
  InActive_Symbol = 'I',
  inActive = 'inActive',
  Max_Length_1 = 1,
  Max_Length_2 = 2,
  Max_Length_3 = 3,
  Max_Length_4 = 4,
  Max_Length_5 = 5,
  Max_Length_6 = 6,
  Max_Length_10 = 10,
  Max_Length_11 = 11,
  Max_Length_22 = 22,
  Max_Length_30 = 30,
  Max_Length_50 = 50,
  Max_Length_100 = 100,
  Max_Length_200 = 200,
  Max_Length_255 = 255,

  DefaultDateTimeFormat = 'MM/DD/YYYY HH:mm:ss A',

  // --idle/keep-alive - constants -- //
  IdleTimeout = 1200, // 20 mins
  ForceTimeout = 120, // 2min

  DateFormat = 'MM/dd/yyyy',
  TimeFormat = 'hh:mm a',
  DsfUserOrganization = 'DSF',
  ReadMode = 'READ',
  EditMode = 'EDIT',
  ProjectTitleRead = 'Read Only',
  ProjectTitleEdit = 'Edit/Change',
  ScaUserOrganization = 'SCA',
  ProjectStatusApproved = 'APPROVED',
  ProjectStatusDSFReady = 'DSF_READY_DATA_RECONCIL',
  ProjectStatusDSFPending = 'DSF_PENDING',
  ProjectStatusSCARejected = 'SCA_REJECTED',
  ProjectStatusSCACanceled = 'SCA_CANCELED',
  ProjectStatusPCExported = 'PC_EXPORTED',
  ProjectStatusSCAReconcilApproved = 'SCA_RECONCIL_APPROVED',
  ProjectStatusDSFCanceled = 'DSF_CANCELED',
  ProjectStatusLLWAssigned = 'LLW_ASSIGNED',

}
export const ModuleConstants = {
  timeDelay: 500,
  exportTime: 5000,
  apiTimeout: 120000,  // 2 min
  kendoGridDefaultTake_0: 0,
  kendoGridDefaultTake_20: 20,
  defaultTakeForExport: 1000,
  kendoDefaultPageSize: { pageSizes: [20, 50, 100] },
  kendoColumnFilterTypeRow: 'row',
  kendoColumnFilterTypeMenu: 'menu',
  kendo_Operation_Add: 1,
  kendo_Operation_Edit: 2,
  securityItemProperty: ['ENABLED', 'VISIBLE'],
  projectTypeRequirementOptions: [{ type: 'R', columnOption: 'Required' }, { type: 'O', columnOption: 'Optional' }, { type: 'N', columnOption: 'N/A' }],
  recipientTypeProperty: [
    { type: 'MAILTO', recipientType: 'mailTO' },
    { type: 'MAILCC', recipientType: 'mailCC' },
  ],
  notificationEventProperty: [
    { type: 'OCP_APPROVE', eventName: 'Project Approved By OCP' },
    { type: 'EHS_NEWJOB', eventName: 'EHS Job Created' },
    { type: 'PDM_SENT_BACK', eventName: 'PDM Sent Back to OCP' },
    { type: 'STA_CAPCAT', eventName: 'CapCat Added in STA' }
  ],
  notificationEventPropertyPDM: [
    { type: 'OCP_APPROVE', eventName: 'Project Approved By OCP' },
    { type: 'PDM_SENT_BACK', eventName: 'PDM Sent Back to OCP' }
  ],
  notificationEventPropertyIEH: [
    { type: 'EHS_NEWJOB', eventName: 'EHS Job Created' }
  ],
  securityItemPropertyValue: ['PROPERTY_TRUE', 'PROPERTY_FALSE'],
  organization: [{ name: 'SCA' }, { name: 'DSF' }],
  projectStatus: [{ value: '1', text: 'CPMD Approval Pending' }, { value: '2', text: 'CPMD Approved Finance/EHS Pending' }, { value: '3', text: 'Finance/EHS Rejected' }, { value: '4', text: 'Finance/EHS Approved' }],
  resoATypeProjectSearch: [{ value: 'C', name: 'City Council' }, { value: 'B', name: 'Borough President' }, { value: 'D', name: 'Dual Funded' }],
  resoAType: [{ value: 'C', name: 'City Council' }, { value: 'B', name: 'Borough President' }, { value: 'D', name: 'Dual Funded' }],
  recordStatus: ['ALL', 'GOOD', 'BAD'],
  relocation: [{ key: 'Yes', value: 'Y' }, { key: 'No', value: 'N' }],
  location: ['Front', 'Back', 'Side'],
  codeValueDataType: ['VARCHAR2', 'NUMBER'],
  llwExportStatus: [{ key: 'Open', value: 'O' }, { key: 'Success', value: 'P' }, { key: 'Fail', value: 'F' }],
  system: ['PTS', 'CPS', 'PPM', 'GRANTS', 'EnFo'],
  systemStatus: [{ key: 'Open', value: 'O' }, { key: 'Processed', value: 'P' }, { key: 'Failed', value: 'F' }],
  kendoGridExportPdfAction: 1,
  kendoGridExportExcelAction: 2,
  kendoGridExportPrintAction: 3,
  kendoGridExportPdfLimit: 1000,
  kendoGridExportExcelLimit: 5000,
  kendoGridExportPrintLimit: 5000,
  // -----Export Limit for DSF Report----//
  dsfReportExportPdfLimit: 250,
  dsfReportExportExcelLimit: 5000,
  dsfReportExportPrintLimit: 500,
  LlwProcessOpenStatus: 'O',
  LlwProcessCompletedStatus: 'P',
  LlwProcessFailureStatus: 'F',
  LlwProcessBatchOpenStatus: 'O',
  InitiateLlwConnectionId: 'getConnectionId',
  InitiateEnfoConnectionId: 'getEnfoConnectionId',
  InitiateLlwHubEvent: 'getLlwExportStatusMessages',
  InitiateEnfoHubEvent: 'getEnfoExportStatusMessages',
  SelectTopRecordsForLlwInitiate: 250,
};


